import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type { NormalizedInterval } from 'date-fns'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class AssessmentScoresRexRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRex = 'rex'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      product,
      uiScope,
      scopedStudents,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRex, scope: StudentsScope, period: NormalizedInterval) {
    const { studentEvents } = this
    return RSVP.hash({
      assessmentScoresAverages: studentEvents.assessmentScoresAverages(product, scope, period),
      assessmentScoresHistory: studentEvents.assessmentScoresByGenreHistory(product, scope, period),
    })
  }
}

export default AssessmentScoresRexRoute
